import axios from "axios";
import toast from "react-hot-toast";

const api = axios.create({
  baseURL: "https://api.20fy.ai",
});

// 🔴 Prevent multiple logout calls
let isLoggingOut = false;

// ================= REQUEST INTERCEPTOR =================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ================= FORCE LOGOUT =================
const forceLogout = () => {
  if (isLoggingOut) return;

  // 🛑 login page la irundha logout panna venda
  if (window.location.pathname === "/") return;

  isLoggingOut = true;

  toast.error("Session expired. Please login again.", {
    duration: 3000,
    position: "top-center",
    style: {
      background: "#ef4444",
      color: "#fff",
      fontWeight: "600",
    },
  });

  localStorage.clear();

  setTimeout(() => {
    window.location.replace("/");
  }, 2000);
};

// ================= RESPONSE INTERCEPTOR =================
api.interceptors.response.use(
  (response) => {
    if (response?.data?.status === 401 && localStorage.getItem("token")) {
      forceLogout();
      return Promise.reject(response);
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem("token")) {
      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default api;